<template>
  <div class="comment wrap">
    <div class="header">
      <NavBar
        title="Reviews"
        left-arrow
        @click-left="$router.go(-1)"
        class="no_bg"
      >
        <!-- <span slot="right" icon="cart-o"><Icon name="cart-o"  badge="99+"/></span> -->
      </NavBar>
    </div>
    <div class="main">
      <div class="top van-hairline--bottom" v-if="pageData">
        <div>Reviews({{ pageData.count }})</div>
        <div class="FlexBox Rates">
          <Rate allow-half readonly v-model="pageData.avgStar" :size="20" />
          <span class="pdl5">{{ pageData.avgStar }}</span>
        </div>
      </div>
      <div class="list" v-for="(item, index) in dataList" :key="index">
        <div class="list_t">
          <div class="FlexBox Rates">
            <span>{{ item.userInfo.name }}</span>
            <Rate
              class="pdl5"
              allow-half
              readonly
              v-model="item.star"
              :size="20"
            />
          </div>
          <div class="liekBox">
            <span :class="item.status == 1 ? 'red' : ''"
              ><van-icon name="good-job-o" size="0.6rem" @click="like(item)"
            /></span>
            <span class="pdl5">{{ item.click }}</span>
          </div>
        </div>
        <div class="list_Text">
          {{ item.content }}
        </div>
        <div class="list_Img">
          <div class="imgBox">
            <div v-for="i in item.imgList" :key="i.productId">
              <div class="imgBox2" v-if="i">
                <VanImage :src="toPicProductImg(i)" lazy-load />
              </div>
            </div>
          </div>
          <!-- <div class="VideoBox">
              <video-player  class="video-player vjs-custom-skin" ref="videoPlayer" :options="playerOptions"></video-player>
            </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/api/request";
import { toPicProductImg } from "../../../utils/common";
export default {
  data() {
    return {
      pageData: {},
      dataList: null,
      userId: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user")).id
        : null, //用户id
      playerOptions: {
        poster: "https://api.btstu.cn/sjbz/api.php?lx=meizi", //视频封面图
        sources: [
          {
            type: "video/mp4", //视频格式
            src:
              "https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4" //视频地址
          }
        ]
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    toPicProductImg,
    like(item) {
      //点赞
      console.log(item, this.userId);
      if (this.userId) {
        let data = {
          commentId: item.commentId,
          status: item.status == 1 ? 0 : 1, //点赞状态：0—>取消赞；1—>点赞
          userId: this.userId
        };
        request("put", "cms/thumbsup/clickOrRemoveClick", data).then(res => {
          if (res.code === 200) {
            this.getData();
            Notify({ type: "success", message: "点赞成功" });
          }
        });
      } else {
        return;
      }
    },
    getData() {
      let data = { productId: this.$route.query.productId , page: 1, limit: 10 };
      if(this.userId){
        data.userId = this.userId
      }
      request("get", "cms/comment/queryCommentByProductId", data).then(res => {
        if (res.code === 200) {
          this.pageData = res.data.commentEntity;
          let data = res.data.page.list;
          this.dataList = data.map(item => {
            item.imgList = item.pic.split(",");
            return item;
          });
          console.log(this.dataList);
          // this.productEntity = res.productEntity
          // this.discount = res.discount
          // this.imgList = res.productEntity.productFileEntity.sugImg.split(',')
          // this.playerOptions.sources[0].src = this.toPicProductImg(res.productEntity.productFileEntity.sugVideo)
          // console.log('单品',this.productEntity)
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
// @import '../../../utils/css/video';
.comment {
  .main {
    background: #fff;
    .top {
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
    }
    .Rates {
      justify-content: start;
      align-items: center;
      // margin-bottom: 5px;
    }
    .list {
      .list_t {
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        .liekBox {
          display: flex;
          align-items: center;
          .red {
            color: red;
          }
        }
      }
      .list_Text {
        padding: 0 10px;
        text-align: left;
      }
      .list_Img {
        padding: 10px;
        text-align: left;
        .imgBox {
          width: 80%;
          display: flex;
          flex-wrap: wrap;
          .imgBox2 .van-image {
            margin: 0 10px 5px 0;
            width: 100px;
            height: 100px;
            img {
              width: 100%;
              max-height: 100%;
            }
          }
          // img{
          //   margin:0 10px 5px 0;
          //   width: 100px;
          //   height: 100px;
          // }
        }
        .VideoBox {
          width: 90%;
        }
      }
    }
    .pdr5 {
      padding-right: 5px;
    }
    .pdl5 {
      padding-left: 5px;
    }
  }
}
</style>
<style>
.comment .video-js {
  height: 200px !important;
}
</style>
